import { PaymentIntegrationsActionType } from './actions';
import { initialState } from './constants';
import { PaymentIntegrationsState, PaymentIntegrationsAction } from './types';

export const paymentIntegrationsReducer = (
  state: PaymentIntegrationsState = initialState,
  action: PaymentIntegrationsAction
): PaymentIntegrationsState => {
  switch (action.type) {
    case PaymentIntegrationsActionType.setStripeStatus:
      return {
        ...state,
        stripe: {
          ...state.stripe,
          status: action.payload,
        },
      };
    case PaymentIntegrationsActionType.setStripeAccountEmail:
      return {
        ...state,
        stripe: {
          ...state.stripe,
          accountEmail: action.payload,
        },
      };
    default:
      return state;
  }
};
